export default __webpack_public_path__ + "static/media/Vishnu-Ghosh-Resume.ab994b31.pdf";